import {  AutocompleteInput, Create, Datagrid, DateField, DateInput, Edit, EditButton, List, NumberField, ReferenceField, ReferenceInput, SelectInput, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput, useGetList } from "react-admin";
const convertEmptyStringToUndefined = v => v === '' ? null : v;

const ParentCompanySelector = () => {
    const  data  = useGetList("parent_companies");
    if(data.isSuccess) {
        return (
            <SelectInput source="parent_company_id" choices={data.data}/>
        );
    }
}

const EmployeeFilters = [
//     <ReferenceInput label="Class" source="position_id" reference="positions">
//     <ReferenceArrayInput label="Teachers" source="company_id" reference="companies">
//         <SelectInput optionText="full_name" optionValue="id"/>
//     </ReferenceArrayInput>
// </ReferenceInput>,
    <ParentCompanySelector label="Parent Company" alwaysOn/>,
    <ReferenceInput source="position_id" reference="positions" alwaysOn><AutocompleteInput optionText="code" optionValue="id" label="Position Code" /></ReferenceInput>,
    <ReferenceInput source="position_id"  reference="positions" ><AutocompleteInput optionValue="id" optionText="name" label="Position Name"/></ReferenceInput>,
    <TextInput label="Registration No" source="registration_number" alwaysOn/>,
    <TextInput label="Employee Name" source="name"/>,
    <DateInput label="Joining From" source="joining_date_gte" alwaysOn/>,
    <DateInput label="Joining To" source="joining_date_lte" alwaysOn/>,
    <DateInput label="Relieved From" source="relieving_date_gte" alwaysOn/>,
    <DateInput label="Relieved To" source="relieving_date_lte" alwaysOn/>,
];

export const EmployeeList = () => (
    <List filters={EmployeeFilters}>
        <Datagrid bulkActionButtons={false}>
        <TextField source="id" />
            <TextField source="name" />
            <TextField source="registration_number" />
            <TextField source="status" />
            <DateField source="joining_date" locales='en-IN'/>
            <DateField source="relieving_date" locales='en-IN'/>
            <ReferenceField source="position_id" reference="positions" link="show"><TextField source="code"/></ReferenceField>
            <ShowButton label="View"/>
            <EditButton label="Edit"/>
        </Datagrid>
    </List>
);

export const EmployeeShow = () => (
    <Show>
        <SimpleShowLayout>
        <TextField source="id" />
            <ReferenceField label="Position Code" source="position_id" reference="positions" link="show"><TextField source="code"/></ReferenceField>
            <ReferenceField source="position_id" reference="positions" link="show"><TextField source="name"/></ReferenceField>
            <TextField source="name" />
            <TextField source="registration_number" />
            <TextField source="status" />
            <DateField source="joining_date" locales='en-IN'/>
            <DateField source="relieving_date" locales='en-IN'/>
            <TextField source="replacement_status" />
            <NumberField source="rate_per_status" label="Contract Rate" options={{ maximumFractionDigits: 2 }} />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </SimpleShowLayout>
    </Show>
);

export const EmployeeEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="registration_number" />
            <TextInput source="status" />
            <DateInput source="joining_date" parse={convertEmptyStringToUndefined}/>
            <DateInput source="relieving_date" parse={convertEmptyStringToUndefined}/>
            <ReferenceInput source="position_id" reference="positions"><AutocompleteInput optionText="code" optionValue="id"/></ReferenceInput>
            <SelectInput source="replacement_status" choices={[
                    { id: 'OC', name: 'OC' },
                    { id: 'R1', name: 'R1' },
                    { id: 'R2', name: 'R2' },
                    { id: 'R3', name: 'R3' },
                    { id: 'R4', name: 'R4' },
                    { id: 'R5', name: 'R5' },
                    { id: 'R6', name: 'R6' },
                    { id: 'R7', name: 'R7' },
                ]} defaultValue='OC' />
        </SimpleForm>
    </Edit>
);

export const EmployeeCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="registration_number" />
            <TextInput source="status" />
            <DateInput source="joining_date" parse={convertEmptyStringToUndefined}/>
            <DateInput source="relieving_date" parse={convertEmptyStringToUndefined}/>
            <ReferenceInput source="position_id" reference="positions"><AutocompleteInput optionText="code" optionValue="id"/></ReferenceInput>
            <SelectInput source="replacement_status" choices={[
                    { id: 'OC', name: 'OC' },
                    { id: 'R1', name: 'R1' },
                    { id: 'R2', name: 'R2' },
                    { id: 'R3', name: 'R3' },
                    { id: 'R4', name: 'R4' },
                    { id: 'R5', name: 'R5' },
                    { id: 'R6', name: 'R6' },
                    { id: 'R7', name: 'R7' },
                ]} defaultValue='OC' />
        </SimpleForm>
    </Create>
);